import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Header
 */
const headerTl = gsap.timeline({
    scrollTrigger: {
        trigger: '#main-page-hero-btn',
        scrub: true,
        start: () => (window.innerWidth > 1200 ? 'top 80px' : 'top 60px'),

        end: '+=100%',
        // toggleActions: 'play pause resume reset',
        // markers: process.env.NODE_ENV === 'development',

        onEnter() {
            document.body.classList.add('main-page--normal-nav');
        },

        onLeaveBack() {
            document.body.classList.remove('main-page--normal-nav');
        },
    },
});

gsap.to('.main-page-hero__content', {
    opacity: 0,
    scrollTrigger: {
        scrub: true,
        trigger: '.main-page-hero__content',
        start: 'top top+=100px',
    },
});

gsap.timeline({
    scrollTrigger: {
        scrub: true,
        trigger: '.main-page-hero__content',
        start: 'top end',
        end: 'top end',
        // markers: true,
        onEnter() {
            document.body.classList.add('main-page--logo-on-mobile');
        },
        onLeaveBack() {
            document.body.classList.remove('main-page--logo-on-mobile');
        },
    },
});
